<template>
    <projects :type="type"></projects>
</template>

<script>
    import Projects from '../components/projects/Projects';
    export default {
        name: "GcpProjects",
        components: { Projects },
        data() {
            return {
                type: 'gcp',
            }
        }
    }
</script>
